export default __webpack_public_path__ + "static/content-d09d2f0ac1760622d73f47508abc0796.jpg";